import { ButtonSize, ButtonVariant, Button as CssModulesButton } from '@sunwebgroup/uds-ui/button'
import * as React from 'react'
import { css, type RuleSet, styled } from 'styled-components'
import { withStyleModifiers } from '../../../utils'
import { SIZE_TO_CSS } from '../../modifier-styles/generated/button'

export type { ButtonSize, ButtonVariant }

interface ButtonWrapperProps extends Omit<
  React.HTMLProps<HTMLButtonElement>,
  /**
   * `size` prop is omitted to avoid conflict with HTML button `size` attribute in React TypeScript definitions.
   */
  'size' | 'as'
> {
  as?: React.ElementType
  variant?: ButtonVariant
  size?: ButtonSize
  fullWidth?: boolean
  isLoading?: boolean
}

function ButtonWrapper({ ref, as, ...props }: ButtonWrapperProps) {
  return (
    <CssModulesButton
      ref={ref}
      as={as}
      {...props}
    />
  )
}

ButtonWrapper.displayName = 'Button'

type MixinName = keyof typeof SIZE_TO_CSS

function modSize(sizeName: ButtonSize = 'M'): RuleSet<object> {
  const mixinName: MixinName = `size-${sizeName.toLowerCase()}` as MixinName
  const cssString = SIZE_TO_CSS[mixinName]
  return css`${cssString ?? ''}`
}

/**
 * @deprecated This component is deprecated and exists only to provide backward compatibility for code that previously relied on styled-components. Please use the corresponding component from '@sunwebgroup/uds-ui/button' instead.
 */

const StyledButton = withStyleModifiers(styled(ButtonWrapper)``, {
  modSize,
  Icon: CssModulesButton.Icon,
})

export default StyledButton
